import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const useClienteDetalles = (id) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [customerdetails, setCustomers] = useState([]);
    const [agrupacionLicencias, setAgrupacionLicencias] = useState([]);
    const [tablaRegimenFiscal, settablaRegimenFiscal] = useState([]);
    const [tablaUsoCFDI, settablaUsoCFDI] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [nivelSoporte, setNivelSoporte] = useState([]);
    const [herramientas, setHerramientas] = useState([]);
    const [isDistribucion, setIsDistribucion] = useState(false);
    const [statusSolucion, setStatusSolucion] = useState([]);
    const [soporte, setSoporte] = useState([]);
    const [ordenes, setOrdenes] = useState([]);
    const [documentosCargados, setDocumentosCargados] = useState({
        docIDFoto: true,
        docCedFiscal: true,
        docCompDomicilio: true,
        docCartaMotivos: true
    });
    const [documentos, setDocumentos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [cargandoEstado, setCargandoEstado] = useState(false);
    const [cargandoFile, setCargandoFile] = useState(false);
    const [editar, setEditar] = useState(false);
    const [editando, setEditando] = useState(false);
    const [cargandoComboBoxSoporte, setCargandoComboBoxSoporte] = useState(false);
    const [licencias, setLicencias] = useState([]);
    const [polizas, setPolizas] = useState([]);
    const [dataFiles, setDataFiles] = useState({ DocFile: null });
    const [leadsVinculados, setLeadsVinculados] = useState([]);
    const [clienteActivityLogs, setClienteActivityLogs] = useState([]);
    const [clientesRepetidos, setClientesRepetidos] = useState([]);

    /**
     * obtiene informacion de un cliente
     */
    const getinformaciondetalladaclientebyid = async () => {
        setCargando(true);

        var objDataSend = {};
        objDataSend.idClienteAkasia = id;

        var jDataSend = JSON.stringify(objDataSend);

        try {
            const response = await fetch("/api/cliente/getinformaciondetalladaclientebyid/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: jDataSend
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var detalles = JSON.parse(data.detalles);

                    setCustomers(detalles['table2'][0]);
                    setAgrupacionLicencias(detalles['table3']);
                    setLicencias(detalles['table4']);
                    setPolizas(detalles['table5']);
                    settablaRegimenFiscal(detalles['table7']);
                    settablaUsoCFDI(detalles['table8']);
                    setCountries(detalles['table9']);
                    setStates(detalles['table10']);
                    setSoporte(detalles['table12']);
                    setLeadsVinculados(detalles['table13']);

                    if (detalles['table14'].length > 0) {
                        var clientesRepetidos = JSON.parse(detalles["table14"][0].vJsonClientesAkasiaRepetidos);
                        const newArray = clientesRepetidos.filter(e => e.idClienteAkasia !== detalles["table2"][0].idClienteAkasia);
                        setClientesRepetidos(newArray);
                    }

                    setDocumentos(detalles['table16']);
                    for (let i = 0; i < detalles["table16"].length; i++) {
                        if (detalles["table16"][i].idTipoDoc == 1)
                            setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docIDFoto: false } })
                        if (detalles["table16"][i].idTipoDoc == 2)
                            setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCedFiscal: false } })
                        if (detalles["table16"][i].idTipoDoc == 3)
                            setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCompDomicilio: false } })
                        if (detalles["table16"][i].idTipoDoc == 4)
                            setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCartaMotivos: false } })
                    }

                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al cargar la información del cliente: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    /**
     * llena el combobox para el soporte tecnico
     */
    const obtenerComboBoxSoporteTecnico = async () => {
        setCargandoComboBoxSoporte(true);
        
        try {
            const response = await fetch("/api/soportetecnico/ObtenerComboBoxesRegistroSoporte/", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setNivelSoporte(data['table1']);
                setHerramientas(data['table2']);
                setStatusSolucion(data['table3']);
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al obtener información de soporte técnico: ' + error.message);
        } finally {
            setCargandoComboBoxSoporte(false);
        }
    };

    /**
     * muestra los estados
     * @param {any} e
     */
    const mostrarEstados = async (e) => {
        setCargandoEstado(true);
        
        try {
            const response = await fetch("/api/cliente/GetStatesByCountry/?vCountryName=" + encodeURIComponent(e), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setStates(data);
            } else {
                setStates([]);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            setStates([]);
            showErrorToast('Hubo un problema al obtener los estados: ' + error.message);
        } finally {
            setCargandoEstado(false);
        }
    };

    /**
     * edita la info del cliente
     * @param {any} key
     * @param {any} values
     */
    const editarInfoCliente = async (key, values) => {
        console.log('=== editarInfoCliente llamado ===');
        console.log('ID Cliente:', key);
        console.log('Values:', values);
        
        setEditando(true);

        try {
            const response = await fetch("/api/cliente/updatecliente/?key=" + key + "&values=" + encodeURIComponent(values), {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            console.log('Response status:', response.status);
            console.log('Response OK:', response.ok);

            if (response.ok) {
                const data = await response.json();
                console.log('Response data:', data);

                if (data.iResponseType == 1) {
                    const objDetalles = JSON.parse(data.detalles)
                    console.log('Detalles actualizados:', objDetalles);
                    setCustomers(objDetalles.table2[0])
                    setEditar(false);
                    setEditando(false);
                    return { success: true, message: 'Se han guardado los datos correctamente' };
                } else {
                    console.error('Error en response:', data.vMessage);
                    showErrorToast(data.vMessage);
                    setEditando(false);
                    return { success: false };
                }
            } else {
                setStates([]);
                setEditando(false);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            console.error('Error en fetch:', error);
            showErrorToast('Hubo un problema al actualizar el cliente: ' + error.message);
            setEditando(false);
            return { success: false };
        }
    };

    /**
     * elimina un cliente
     * */
    const eliminarCliente = async () => {
        try {
            const response = await fetch("/api/cliente/EliminarCliente/?key=" + id, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    await getinformaciondetalladaclientebyid();
                    return { success: true, message: data.vMessage || 'Cliente eliminado correctamente' };
                } else {
                    showErrorToast(data.vMessage || 'No se pudo eliminar el cliente');
                    return { success: false };
                }
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            console.error('Error en eliminarCliente:', error);
            showErrorToast(error.message || 'Error desconocido al eliminar el cliente');
            return { success: false };
        }
    };

    /**
     * registra el soporte tecnico
     * @param {any} values
     */
    const registrarSoporteTecnico = async (values) => {
        try {
            const response = await fetch("/api/soportetecnico/RegistrarSoporteTecnico/?values=" + encodeURIComponent(values), {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                setEditar(false);
                await getinformaciondetalladaclientebyid();
                return { success: true, message: 'Se han guardado los datos correctamente' };
            } else {
                setStates([]);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al registrar el soporte técnico: ' + error.message);
            return { success: false };
        }
    };

    /**
     * combina la información de 2 clientes en uno solo para evitar tener clientes repetidos
     */
    const combinarClientes = async (idClienteAkasiaACombinar) => {
        var jDataSend = {};
        jDataSend.idClienteAkasia = customerdetails.idClienteAkasia
        jDataSend.idClienteAkasiaACombinar = idClienteAkasiaACombinar

        try {
            const response = await fetch("/api/cliente/CombinarClientes/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    await getinformaciondetalladaclientebyid();
                    showSuccessToast('Clientes combinados exitosamente');
                    return { success: true };
                } else {
                    showErrorToast(data.vMessage);
                    return { success: false };
                }
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al combinar los clientes: ' + error.message);
            return { success: false };
        }
    };

    //Enviar Archivo DocFile
    const onSubmitDocFile = async (idTipoDoc) => {
        if (dataFiles.DocFile == null || dataFiles.DocFile.length == 0) {
            showErrorToast('Es obligatorio subir un documento para enviar');
            return { success: false };
        }

        setCargandoFile(true);

        var data = new FormData()
        data.append('DocFile', dataFiles.DocFile);
        data.append('idClienteAkasia', id);
        data.append('idTipoDoc', idTipoDoc)

        try {
            const response = await fetch("/api/distribuidor/SubirDocFile", {
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                setDocumentos(data);

                setDocumentosCargados({
                    docCompDomicilio: true,
                    docCartaMotivos: true,
                    docCedFiscal: true,
                    docIDFoto: true
                });

                for (let i = 0; i < data.length; i++) {
                    if (data[i].idTipoDoc == 1)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docIDFoto: false } })
                    if (data[i].idTipoDoc == 2)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCedFiscal: false } })
                    if (data[i].idTipoDoc == 3)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCompDomicilio: false } })
                    if (data[i].idTipoDoc == 4)
                        setDocumentosCargados(documentosCargados => { return { ...documentosCargados, docCartaMotivos: false } })
                }
                
                showSuccessToast('Documento cargado exitosamente');
                setDataFiles({ DocFile: null })
                return { success: true };
            } else {
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                return { success: false };
            }
        } catch (error) {
            showErrorToast('Hubo un problema al subir el documento: ' + error.message);
            return { success: false };
        } finally {
            setCargandoFile(false);
        }
    };

    return {
        // Estados
        customerdetails,
        agrupacionLicencias,
        tablaRegimenFiscal,
        tablaUsoCFDI,
        countries,
        states,
        nivelSoporte,
        herramientas,
        isDistribucion,
        setIsDistribucion,
        statusSolucion,
        soporte,
        ordenes,
        setOrdenes,
        documentosCargados,
        setDocumentosCargados,
        documentos,
        cargando,
        cargandoEstado,
        cargandoFile,
        editar,
        setEditar,
        editando,
        cargandoComboBoxSoporte,
        licencias,
        polizas,
        dataFiles,
        setDataFiles,
        leadsVinculados,
        setLeadsVinculados,
        clienteActivityLogs,
        setClienteActivityLogs,
        clientesRepetidos,

        // Métodos
        getinformaciondetalladaclientebyid,
        obtenerComboBoxSoporteTecnico,
        mostrarEstados,
        editarInfoCliente,
        eliminarCliente,
        registrarSoporteTecnico,
        combinarClientes,
        onSubmitDocFile
    };
};

export default useClienteDetalles;
